import {API_EVENT_START, API_EVENT_SUCCESS, API_EVENT_FAIL, API_EVENT_RESET} from './constants';
import {ApiEventActions, ApiEventState} from './types';

const initialState: ApiEventState = {
  loading: false,
  data: undefined,
  error: undefined,
};

const reducer = (
  state = initialState,
  action: ApiEventActions,
): ApiEventState => {
  switch (action.type) {
    case API_EVENT_START:
      return {
        ...initialState,
        loading: true,
      };
    case API_EVENT_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case API_EVENT_FAIL:
     return {
        ...state,
        loading: false,
        error: action.error,
      };
    case API_EVENT_RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default reducer;
